/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_UnlimitedInputs */

const en_coaching_unlimited = /** @type {(inputs: Coaching_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited sessions`)
};

const id_coaching_unlimited = /** @type {(inputs: Coaching_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi tanpa batas`)
};

/**
* | output |
* | --- |
* | "Unlimited sessions" |
*
* @param {Coaching_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_unlimited = /** @type {((inputs?: Coaching_UnlimitedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_UnlimitedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_unlimited(inputs)
	return en_coaching_unlimited(inputs)
});